import clsx from "clsx";
import { useLayoutEffect, useRef, useState } from "react";
import { ChevronDown, ChevronUp, X } from "react-bootstrap-icons";
import type { ViewCommunicationItem } from "@/briefpoint-client";
import type { Interrogatory } from "@/briefpoint-client/models/Interrogatory";
import { Button } from "../ui/button";
import styles from "./ReviewClientTaskInterrogatoryBox.module.scss";

interface Props {
  interrogatory: Interrogatory | null;
  communication: ViewCommunicationItem;
  removeInterrogatory: () => void;
}

export default function ReviewClientTaskInterrogatoryBox(props: Props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const [canExpand, setCanExpand] = useState(false);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const updateCanExpand = () => {
      if (!isExpanded) {
        // Line-clamped text: scrollHeight is full content; clientHeight is the visible box. -4 is to compensate for padding.
        setCanExpand(el.scrollHeight - 4 > el.clientHeight);
      }
    };

    updateCanExpand();

    const ro = new ResizeObserver(updateCanExpand);
    ro.observe(el);
    return () => ro.disconnect();
  }, [isExpanded]);

  return (
    <div className={styles.clientUploadsContent}>
      <div
        ref={textRef}
        className={clsx(
          styles.clientUploadsContentText,
          isExpanded ? styles.expanded : styles.truncated,
        )}
      >
        <b>No. {props.interrogatory?.number}: </b>
        {props.interrogatory?.text}
      </div>
      <div className={styles.clientUploadsAction}>
        <Button
          variant="ghost"
          size="sm"
          type="button"
          onClick={props.removeInterrogatory}
          className={styles.communicationActionButton}
        >
          <X style={{ scale: 1.5 }} />
        </Button>
        {canExpand && (
          <Button
            variant="ghost"
            size="sm"
            type="button"
            onClick={() => setIsExpanded(!isExpanded)}
            className={styles.communicationActionButton}
          >
            {isExpanded ? <ChevronUp /> : <ChevronDown />}
          </Button>
        )}
      </div>
    </div>
  );
}
